import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0C1D36] text-[#FDFBF7] mt-24" data-testid="site-footer">
      <div className="container-editorial py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <div className="mb-6 inline-block bg-white p-3">
              <img
                src="/brand/usa-bookkeeping-logo.png"
                alt="USA Bookkeeping Solutions LLC"
                className="h-20 w-auto"
              />
            </div>
            <p className="font-serif italic text-xl leading-snug text-white/85 max-w-md">
              “Accuracy isn't a feature, it's the baseline.”
            </p>
            <p className="mt-6 text-sm text-white/60 max-w-md">
              Bookkeeping built for law firms. Trust accounting, 3-way reconciliation,
              and financial systems that hold up under scrutiny.
            </p>
          </div>

          <div className="md:col-span-5 md:flex md:justify-end">
            <div className="md:max-w-xs w-full">
              <div className="eyebrow-muted text-white/60 mb-4">Connect</div>
              <ul className="space-y-3 text-sm text-white/80">
                <li className="flex items-start gap-2">
                  <Mail className="w-4 h-4 mt-0.5 text-[#BA1A1A] flex-shrink-0" />
                  <a
                    href="mailto:info@usabookkeepingllc.com"
                    className="break-all hover:text-[#BA1A1A]/90"
                  >
                    info@usabookkeepingllc.com
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <Phone className="w-4 h-4 mt-0.5 text-[#BA1A1A] flex-shrink-0" />
                  <a href="tel:+15616211495" className="hover:text-[#BA1A1A]/90">+1 561-621-1495</a>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 mt-0.5 text-[#BA1A1A] flex-shrink-0" />
                  <span>United States</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-white/50 tracking-wide">
            © {new Date().getFullYear()} USA Bookkeeping Solutions LLC. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-white/50">
            <a
              href="https://drive.google.com/file/d/1aG_hbt_x7TvSSWIR0eCfWQrzWb9VVzRe/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#BA1A1A]/90 link-underline"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </a>
            <a
              href="https://drive.google.com/file/d/1E1-z2_VmKodSQuIvuwEYUguDrjJjYfYw/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#BA1A1A]/90 link-underline"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </a>
            <span>IOLTA-aware bookkeeping. Not legal or tax advice.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
